import {Formatter} from './units-formatter';

export class NumberWithDecimalsFormatter extends Formatter {
  apply(numberText: any): string {

    if (typeof numberText === 'string') {
      numberText = parseFloat(numberText);
    }

    if (isNaN(numberText)) {
      return '';
    } else {
      return numberText.toFixed(this.numberDecimals);
    }
  }
}
